import { render, staticRenderFns } from "./MessageSendingForm.vue?vue&type=template&id=5c45c9a6&scoped=true&"
import script from "./MessageSendingForm.vue?vue&type=script&lang=ts&"
export * from "./MessageSendingForm.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSendingForm.vue?vue&type=style&index=0&id=5c45c9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c45c9a6",
  null
  
)

export default component.exports